import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cfc52d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "搜索", -1))
const _hoisted_2 = { class: "search-hint" }
const _hoisted_3 = {
  key: 0,
  class: "function-search-results",
  "aria-label": "功能搜索结果"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "进入 →", -1))
const _hoisted_6 = { key: 0 }

import { locateFunctionTarget } from '@/utils/functionSearchFocus'
import { computed, nextTick, ref, watch, onBeforeUnmount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { SearchOutlined } from '@ant-design/icons-vue'
import store from '@/store'
import { buildFunctionSearch, searchFunctions, FunctionSearchItem } from '@/utils/adminFunctionSearch'
import { adminFunctionDescriptions } from '@/utils/adminFunctionDescriptions'
import { generateTitle } from '@/utils/lang'
import { administrationTitleKey } from '@/utils/platformAdministration'
import { canConfigureFunctionGuides } from '@/utils/functionGuides'

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchText',
  setup(__props) {

const router = useRouter(), route = useRoute()
const visible = ref(false), query = ref(''), selected = ref(0), input = ref()
const canOpen = (path: string) => {
  const resolved = router.resolve(path), meta = resolved.meta, user = store.getters.userInfo
  return Boolean(resolved.matched.length && !resolved.matched.some(item => item.path.includes(':'))
    && (!meta.requiresPlatform || Number(user.orgId) === 1000)
    && (!meta.requiresPlatformSuperAdmin || Number(user.orgId) === 1000 && Number(user.roleId) === 1)
    && (!meta.requiresFunctionGuides || canConfigureFunctionGuides(user, store.getters.functions?.allFunc)))
}
const catalog = computed(() => store.getters.token ? buildFunctionSearch(store.getters.functions?.allFunc, store.getters.functions?.parentFunc, store.getters.userInfo,
  (key, fallback) => generateTitle(administrationTitleKey(key, store.getters.userInfo.orgId), fallback), adminFunctionDescriptions, canOpen) : [])
const results = computed(() => searchFunctions(catalog.value, query.value))
watch(results, async () => { selected.value = 0; await nextTick(); const list=document.querySelector('.function-search-results');if(list)list.scrollTop=0 })
watch(visible, async value => { if (value) { await nextTick(); input.value?.focus() } })
watch(() => [store.getters.token, store.getters.userInfo?.id, store.getters.userInfo?.orgId].join(':'), () => { visible.value = false; query.value = '' })
watch(() => route.fullPath, () => { visible.value = false })
const open = (item: FunctionSearchItem) => {
  if (!catalog.value.some(current => current.id === item.id && current.path === item.path) || !canOpen(item.path)) return
  visible.value = false; query.value = ''
  const destination=router.resolve(item.path);router.push({path:destination.path,query:{...destination.query,...(destination.path==='/products/bokes'?{productType:0}:{}),_find:String(Date.now())}})
}
let clearFocus:()=>void=()=>undefined
watch(()=>route.fullPath,async()=>{clearFocus();await nextTick();const focus=route.query.focus;if(typeof focus==='string' && focus.length<=100)clearFocus=locateFunctionTarget(focus)},{immediate:true})
onBeforeUnmount(()=>clearFocus())
const onKey = (event: KeyboardEvent) => {
  if (event.isComposing || !results.value.length) return
  if (event.key === 'Enter') { event.preventDefault(); open(results.value[selected.value]) }
  if (['ArrowDown', 'ArrowUp'].includes(event.key)) {
    event.preventDefault(); selected.value = (selected.value + (event.key === 'ArrowDown' ? 1 : -1) + results.value.length) % results.value.length
    nextTick(() => document.querySelector('.function-search-results button.selected')?.scrollIntoView({ block: 'nearest' }))
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      class: "function-search-trigger",
      type: "text",
      "aria-label": "全局功能搜索",
      title: "搜索功能",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(SearchOutlined)),
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      title: "搜索功能",
      footer: null,
      width: 620,
      onAfterClose: _cache[3] || (_cache[3] = ($event: any) => (query.value = ''))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_input, {
          ref_key: "input",
          ref: input,
          value: query.value,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((query).value = $event)),
          "allow-clear": "",
          placeholder: "输入功能名称或用途，如：订单、皮肤、客户",
          "aria-label": "搜索管理端功能",
          onKeydown: onKey
        }, {
          prefix: _withCtx(() => [
            _createVNode(_unref(SearchOutlined))
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("p", _hoisted_2, [
          _createTextVNode("仅显示当前账号有权限的功能；点击结果直接进入。"),
          _createElementVNode("span", null, _toDisplayString(results.value.length) + " 项", 1)
        ]),
        (results.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (item, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.id,
                  type: "button",
                  class: _normalizeClass({ selected: selected.value === index }),
                  onClick: ($event: any) => (open(item))
                }, [
                  _createElementVNode("strong", null, [
                    _createTextVNode(_toDisplayString(item.title), 1),
                    _hoisted_5
                  ]),
                  _createElementVNode("small", null, _toDisplayString(item.group), 1),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createBlock(_component_a_empty, {
              key: 1,
              description: "未找到可使用的功能，请更换关键词或联系管理员核对权限。"
            }))
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})